import React from 'react'

const Contact = () => {
  return (
    <div className='twelvefiftycontent'><h1 className='page-title'>Contact</h1></div>
  )
}

export default Contact